<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="resumen/baja"></app-filtros-reportes>
      <a id="tipo" (click)="ctrl.tipo=1"></a>
      <div style="overflow:auto;  height: 77.5vh;">
        <div id="imprimir">
          <!--Tabla -->
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando " id="tabla">
            <thead>
              <tr>
                <th>
                  <abbr>Nombre</abbr>
                </th>
                <th>Matrícula</th>
                <th>Sexo</th>
                <th>Movil</th>
                <th>Tel. casa</th>
                <!-- <th>CURP</th> -->
                <th>Carrera</th>
                <th>Grupo</th>
                <th>Período escolar</th>

                <th>Fecha Alta</th>
                <th>Fecha Modificación</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of ctrl.datos; let i=index">
                <th style="vertical-align: middle;">{{ item.alumnos_metadatos.apellido_paterno }}
                  {{ item.alumnos_metadatos.apellido_materno }} {{ item.alumnos_metadatos.nombre }}
                </th>
                <td style="vertical-align: middle;">{{ item.matricula }} </td>
                <td style="vertical-align: middle;">{{ item.alumnos_metadatos.sexo }}</td>
                <td style="vertical-align: middle;">{{ item.alumnos_metadatos?.telefono_contacto_movil }}</td>
                <td style="vertical-align: middle;">{{ item.alumnos_metadatos?.telefono_contacto_casa }}</td>
                <td style="vertical-align: middle;">{{ item.carreras_planes?.carrera }}</td>
                <td style="vertical-align: middle;">
                  {{ item.inscripciones.length ? item.inscripciones[0].grupos_inscripciones.clave+' / '+item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.modalidades.nombre : '' }}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.inscripciones.length ? item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.fecha_inicio +' / '+ item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.fecha_fin : '' }}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.created_at}}
                </td>
                <td style="vertical-align: middle;">
                  {{ item.updated_at}}
                </td>

              </tr>
              <tr *ngIf="ctrl.datos.length == 0">
                <td colspan="8" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
              </tr>
            </tbody>

          </table>

        </div>
      </div>
    </div>
  </div>
</div>
